import clsx from 'clsx';
import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import AboutUsSiteInnerContainer from 'components/about-us/AboutUsSiteInnerContainer';
import MainLayout from 'components/layout/MainLayout';
import { ReferralBeachHeaderFullWidth } from 'components/referrals/2026/ReferralBeachHeaderFullWidth';
import { ReferralsHowItWorks } from 'components/referrals/2026/ReferralsHowItWorks';
import type { PlayerInvitee } from 'hooks/referrals/usePlayerInvitesAndInvitees';
import { useReferralsSharedWins } from 'hooks/referrals/useReferralsSharedWins';
import { ReferralsFAQs } from './faqs';
import styles from './referrals.module.css';
import { WhatCanWeWin } from './what-can-we-win';
import YourSharedWins from './YourSharedWins';

interface ReferralsPageContentProps {
  loading: boolean;
  referees: PlayerInvitee[];
  referrerName?: string;
  referrerAvatarUrl?: string;
}

export const ReferralsPageContent = ({
  loading,
  referees,
  referrerName,
  referrerAvatarUrl,
}: ReferralsPageContentProps) => {
  const sharedWins = useReferralsSharedWins();
  const hasSharedWins = (sharedWins?.length ?? 0) > 0;

  return (
    <MainLayout limitItemWidths noHeaderDropShadow>
      <div className={clsx('aboutUsTypographyReset', styles.outerContainer)}>
        <ReferralBeachHeaderFullWidth
          loading={loading}
          referrerName={referrerName}
          referrerAvatarUrl={referrerAvatarUrl}
          referees={referees}
        />

        <AboutUsModule background="grey" withReducedPadding>
          <AboutUsSiteContainer
            twoColumn={hasSharedWins ? 'reverse' : false}
            overlapAbove
          >
            <AboutUsSiteInnerContainer>
              <div className={styles.howItWorksCard}>
                <ReferralsHowItWorks
                  stepsStyle={hasSharedWins ? 'column' : 'row'}
                />
              </div>
            </AboutUsSiteInnerContainer>
            {sharedWins && hasSharedWins && (
              <AboutUsSiteInnerContainer
                background="white"
                borderRadius
                withPadding
              >
                <YourSharedWins sharedWins={sharedWins} />
              </AboutUsSiteInnerContainer>
            )}
          </AboutUsSiteContainer>
        </AboutUsModule>

        <WhatCanWeWin inviteesCount={referees.length} />
        <ReferralsFAQs />
      </div>
    </MainLayout>
  );
};
